// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29eUw","importantInfo":"styles_importantInfo__3_apu"};